import React from "react"
import { Link } from "gatsby"
import NewsLetter from "./Newsletter"

const SiteMapSection = () => {
	const companySiteMap = [
		{ label: "About Us", link: "/about-us" },
		{ label: "Our Commitment", link: "/our-commitment" },
		{ label: "Rewards", link: "/blackbough-beach-club" },
		{ label: "Reviews", link: "/blackbough-reviews" },
		// { label: "Press", link: "/blogs/press" },
		// { label: "Blog", link: "/blogs/the-blackbough-blog" },
		{ label: "Gift Card", link: "/products/gift-card" },
		// { label: "Student Discount", link: "/student-discount" },
	];

	const productSiteMap = [
		{
			label: "FAQs",
			link: "https://black-bough-swim.reamaze.com/",
			external: true,
		},
		// { label: "Shipping", link: "/shipping-and-order-information", external: false },
		{
			label: "General Size Guide",
			link: "/blackbough-size-guide",
			external: false,
		},
		// { label: "Stockists", link: "/stockists", external: false },
		// { label: "Request A Return", link: "/request-a-return", external: false },
		{ label: "Contact Us", link: "/contact-us", external: false },
		// { label: "Beach Club", link: "/blackbough-beach-club", external: false },
	];

	return (
		<React.Fragment>
			<section className="max-container site-map grid grid-cols-1 md:grid-cols-2 items-start gap-x-6 gap-y-20">
				<section className="flex justify-start order-2 md:order-1 text-center md:text-left">
					<div className="flex-1">
						<h5>BLACKBOUGH SWIM</h5>
						<ul>
							{companySiteMap.map((item, index) => {
								return (
									<li key={`company-sm-${index}`}>
									<Link
										className="hover:underline hover:underline-offset-4"
										to={item.link}
										aria-label={item?.label}
									>
										{item.label}
									</Link>
									</li>
								);
							})}
						</ul>
					</div>
					<div className="flex-1">
						<h5>CUSTOMER CARE</h5>
						<ul className="site-map">
							{productSiteMap.map((item, index) => {
								if (item.external) {
									return (
									<li key={`company-sm-${index}`}>
										<a
										className="hover:underline hover:underline-offset-4"
										href={item.link}
										aria-label={item?.label}
										target="_blank"
										>
										{item.label}
										</a>
									</li>
									);
								}

								return (
									<li key={`company-sm-${index}`}>
									<Link
										className="hover:underline hover:underline-offset-4"
										to={item.link}
										aria-label={item?.label}
									>
										{item.label}
									</Link>
									</li>
								);
							})}
						</ul>
					</div>
				</section>

				<NewsLetter />
			</section>
		</React.Fragment>
	);
};

export default SiteMapSection
